/** @module csi/widget/LabeledImage */
define([
	"dojo/_base/declare",
	"dijit/_WidgetBase",
	"dijit/_TemplatedMixin",
	"dojo/text!./LabeledImage.html"
], function(declare, _WidgetBase, _TemplatedMixin, templateString) {

	return declare([_WidgetBase, _TemplatedMixin], {
		baseClass: "csi-labeled-image",
		templateString,

		// attach points
		// imageContainer: null,
		// imageNode: null,

		/** @property {string} imageLabel - The label to display above the image */
		imageLabel: "",

		/** @property {string} imageSrc - The source of the image to display */
		imageSrc: "",

		/** @property {CSSProperties} imageContainerStyle - optional image container style */
		imageContainerStyle: null,

		/** post create lifecycle method */
		postCreate() {
			Object.assign(this.imageContainer.style, this.imageContainerStyle);
		},

		_setImageSrcAttr: function(value) {
			this._set("imageSrc", value);
			this.imageNode.src = value;
		}
	});
});